import React from 'react'

import { Button, Checkbox, TextInput } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func } from 'prop-types'

import RichEditor from 'Pods/Shared/RichEditor/RichEditor'

import DeadlineField from './Components/DeadlineField/DeadlineField'
import SoftwareField from './Components/SoftwareField/SoftwareField'
import VisualReferences from './Components/VisualReferences/VisualReferences'
import useAssistForm, { BUDGET_MIN } from './Hooks/useAssistForm'

const TERMS_LABEL = (
  <span>
    {'I agree with the '}
    <a href="/pages/terms-and-conditions" target="_blank" rel="noopener noreferrer">Terms and Conditions</a>
    <b className="cgt-legacy-color-utility-danger-100"> *</b>
  </span>
)

function AssistForm({ onSuccess }) {
  const {
    data,
    softwareOptions,
    showErrors,
    isSubmitting,
    errorFor,
    handleFieldChange,
    handleDescriptionChange,
    handleSoftwareChange,
    handleDayChange,
    handleEndlessChange,
    handleReferencesChange,
    handleResellChange,
    handleTermsChange,
    handleSubmit,
  } = useAssistForm(onSuccess)

  return (
    <form className="assist-tab" onSubmit={handleSubmit} autoComplete="off" noValidate>
      <div className="assist-tab__fields">
        <span className="cgt-heading-50">Request for Designer Assistance</span>

        <TextInput
          id="assist-title"
          name="title"
          label="Title"
          size="small"
          placeholder="Type here..."
          value={data.title}
          onChange={handleFieldChange}
          isWarning={!!errorFor('title')}
          helpText={errorFor('title') || undefined}
          isPilot
          isRequired
        />

        <RichEditor
          label="Description"
          required
          value={data.description}
          onChange={handleDescriptionChange}
          showError={showErrors}
          errorText={errorFor('description')}
          useNewStyles
          minHeight={120}
          labelClassName="cgt-body-base-semibold"
        />

        <SoftwareField
          options={softwareOptions}
          selected={data.software}
          onChange={handleSoftwareChange}
          errorText={errorFor('software')}
        />

        <VisualReferences onChange={handleReferencesChange} />

        <div>
          <div className="assist-tab__row">
            <DeadlineField
              deadline={data.deadline}
              isEndless={data.isEndless}
              onDayChange={handleDayChange}
              onEndlessChange={handleEndlessChange}
              errorText={errorFor('deadline')}
            />

            <TextInput
              id="assist-budget"
              name="budget"
              label="Budget"
              inputType="number"
              isCurrency
              step="1"
              placeholder={`${BUDGET_MIN}`}
              value={data.budget}
              onChange={handleFieldChange}
              isWarning={!!errorFor('budget')}
              helpText={errorFor('budget') || undefined}
              isPilot
              isRequired
              size="small"
              wrapperClassName="assist-tab__budget"
            />
          </div>

          <div className="assist-tab__agreement">
            <Checkbox
              id="assist-resell"
              name="resell"
              size="medium"
              checkedColor="primary"
              isControlled
              isChecked={data.resell}
              onChange={handleResellChange}
              label="I allow the designer to sell Project results on the marketplace"
              className="assist-tab__checkbox"
            />
            <Checkbox
              id="assist-terms"
              name="terms"
              size="medium"
              checkedColor="primary"
              isControlled
              isChecked={data.terms}
              onChange={handleTermsChange}
              label={TERMS_LABEL}
              className="assist-tab__checkbox"
            />
          </div>
        </div>
      </div>

      <div className="assist-tab__footer">
        <Button type="primary" size="medium" actionType="submit" expand disabled={!data.terms || isSubmitting}>
          Post a Project
        </Button>
      </div>
    </form>
  )
}

AssistForm.propTypes = {
  onSuccess: func.isRequired,
}

export default AssistForm
